<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <h2 class="text-primary">
          <i class="fas fa-cash-register" /> Gerenciar Caixas
        </h2>
        <small class="text-muted"
          >Controle seus caixas, permissões e outros.</small
        >
        <div class="col-md-12 align-items-end mb-3 text-right">
          <button
            class="btn btn-success"
            style="margin-left: 5px"
            @click="openAccountStoreForm()"
          >
            <i class="fas fa-pen" />
            <span class="d-none d-md-inline">Adicionar Caixa</span>
          </button>
        </div>
      </div>
    </div>

    <!-- table list -->
    <br />
    <br />

    <div class="row grid-table-heading">
      <div class="col-md-4">Descrição</div>
      <div class="col-md-6">Acesso</div>
      <div class="col-md-2">Status</div>
    </div>
    <hr />

    <template v-for="(row, index) in accounts">
      <div
        class="row grid-table-row"
        :key="row.id"
        @click="openAccountStoreForm(row.id)"
      >
        <div class="col-md-4">
          <account-label :account="row" />
        </div>

        <div class="col-md-6">
          <template v-if="row.free_access == 1">Acesso livre</template>
          <template v-else>
            <avatar
              :title="user.name"
              class="mr-2"
              v-for="(user, userIndex) in row.account_permission_join_user"
              :key="index + '/' + userIndex"
              inline
              color="#fff"
              :size="30"
              :username="user.name"
              :initials="user.name.slice(0, 1)"
            ></avatar>
          </template>
        </div>

        <div class="col-md-2">
          <template v-if="row.status == 1">
            <span class="badge badge-success text-white">Ativo</span>
          </template>
          <template v-else>
            <span class="badge badge-danger text-white">Inativo</span>
          </template>
        </div>
      </div>
    </template>
    <!-- table list -->

    <error-handler :error="error" />
    <account-store-form ref="accountStoreForm" @stored="select" />
  </div>
</template>

<script>
import Filters from "./../../mixins/Filters.js";
import TablePaginator from "./../../components/sections/TablePaginator";
import Avatar from "vue-avatar";
import AccountStoreForm from "../../components/account/forms/AccountStoreForm";
import accountLabel from "@/components/account/sections/AccountLabel";

export default {
  components: {
    TablePaginator,
    Avatar,
    AccountStoreForm,
    accountLabel,
  },

  data: function () {
    return {
      //accounts: {},

      type: {
        c: {
          text: "Caixa",
          class: "badge-success",
        },

        b: {
          text: "Banco",
          class: "badge-primary",
        },
      },

      error: null,
    };
  },

  created() {
    this.$store
      .dispatch("account/getAccounts")
      .then((response) => {
        this.$store.commit("pageHasLoaded");
      })
      .catch((error) => {
        this.error = error;
        this.$store.commit("pageHasLoadedWithError", { error: error });
      });
  },

  computed: {
    accounts() {
      return this.$store.state.account.accounts;
    },
  },

  methods: {
    openAccountStoreForm(id = null) {
      this.$refs.accountStoreForm.open(id);
    },

    select() {
      this.$store.dispatch("account/getAccounts");
    },
  },
};
</script>

